import React from 'react';
import PropTypes from 'prop-types';
import PhoneInputField from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { getDefaultUserCountry } from 'components/Authentication/functions';
import phoneIconSrc from 'assets/icons/phone.svg';
import './PhoneInput.css';

const PhoneInput = ({
  country, onChange, onenter, value,
}) => (
  <div className="phone-input">
    <PhoneInputField
      country={country || getDefaultUserCountry() || 'us'}
      value={value}
      specialLabel=""
      buttonClass="phone-input-dropdown"
      onEnterKeyPress={() => {
        if (onenter) onenter();
      }}
      onChange={onChange}
    />
    <img className="icon" src={phoneIconSrc} alt="" />
  </div>
);

PhoneInput.propTypes = {
  country: PropTypes.any,
  onChange: PropTypes.func,
  onenter: PropTypes.func,
  value: PropTypes.string,
};

export default PhoneInput;
